import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import marked from "marked";

const PostItem = ({ post }) => {
  const containerRef = useRef(null);
  const outerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [height, setHeight] = useState("fit-contents");
  const [showAll, setShowAll] = useState(false);

  const toggleClass = (entries) => {
    // console.log(entries);
    const [entry] = entries;
    // console.log(entry);
    setIsVisible(entry.isIntersecting);
  };

  const options = {
    threshold: 0.2,
  };

  // useEffect(() => {
  //   const dynamicHeight = containerRef.current.scrollHeight;

  //   if (containerRef.current) {
  //     if (dynamicHeight > 440) {
  //       setHeight(showAll ? dynamicHeight : 400);
  //     }
  //   }
  // }, [containerRef, showAll]);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(toggleClass, options);
  //   if (containerRef.current) {
  //     return observer.observe(containerRef.current);
  //   }

  //   return () => {
  //     if (containerRef.current) observer.unobserve(containerRef.current);
  //   };
  // }, [containerRef, options]);

  const date = new Date(post.date);
  return (
    <div ref={outerRef} className='post-item-container'>
      <div
        style={{ height: "fit-content" }}
        ref={containerRef}
        className={`post-item ${isVisible ? "color" : ""}`}
      >
        <div className='post-item__header'>
          <div className='post-item__header__left'>
            {post.title && <h1>{post.title}</h1>}
            <p>{date.toDateString()}</p>
          </div>
          {post.mainImage && (
            <div className='post-item__header__right'>
              <img src={post.mainImage.fields.file.url} />
            </div>
          )}
        </div>
        <div
          className='post-item__body'
          dangerouslySetInnerHTML={{ __html: marked(post?.body) }}
        />
        <hr />
        {post.downloadPdf && (
          <div style={{ marginTop: 40 }}>
            <a
              className='button'
              download
              href={post.downloadPdf.fields.file.url}
              target='_blank'
            >
              Download PDF
            </a>
          </div>
        )}

        {/* {!showAll && <div className='fade-out' />} */}
      </div>
      {/* {containerRef.current && containerRef.current.scrollHeight > 450 && ( */}
      {/* <div className='more-button'>
        <button onClick={() => setShowAll(!showAll)}>
          {!showAll ? "show more" : "hide"}
        </button>
      </div> */}
      {/* )} */}
    </div>
  );
};

export default PostItem;
